'use strict';

module.exports = require('react/lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/company/react/build/packages/react-dom/server.js
 ** module id = 312
 ** module chunks = 1
 **/